module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/sb-account-grid/sb-account-grid.component.css
// module id = ./src/app/accountmaster/sb-account-grid/sb-account-grid.component.css
// module chunks = main